/**
 * /cases: đương sự xem CasesPage; staff → Bảng điều khiển (tab Vụ án của tôi).
 */
import { Navigate } from 'react-router-dom'
import { useAppSelector } from '../hooks/redux'
import CasesPage from '../pages/cases/CasesPage'
import { workspaceHash, WORKSPACE_SECTION_IDS } from '../pages/workspace/workspaceSectionIds'

const STAFF_ROLES = ['secretary', 'judge', 'admin', 'chief_judge']

export default function CasesEntryRoute() {
  const role = useAppSelector((s) => s.auth.user?.role)
  if (role && STAFF_ROLES.includes(role)) {
    return <Navigate to={workspaceHash(WORKSPACE_SECTION_IDS.vuAnCuaToi)} replace />
  }
  return <CasesPage />
}
